export default __webpack_public_path__ + "806a03b546d4c74de4bbe2e06a5014dc.png";